module.exports = __webpack_public_path__ + "img/feature_buy_en.8a19413b.png";